// removed by extract-text-webpack-plugin
module.exports = {"row":"SocialLinkRow-style__row__c40521aa","item":"SocialLinkRow-style__item__c40521aa","link":"SocialLinkRow-style__link__c40521aa","twitter":"SocialLinkRow-style__twitter__c40521aa","facebook":"SocialLinkRow-style__facebook__c40521aa","pinterest":"SocialLinkRow-style__pinterest__c40521aa","instagram":"SocialLinkRow-style__instagram__c40521aa"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Footer/SocialLinkRow/SocialLinkRow-style.scss
// module id = ./src/components/Footer/SocialLinkRow/SocialLinkRow-style.scss
// module chunks = 13